import {appendPaginationQueryParamsToUrl} from "../utils";

export default host => (options) => appendPaginationQueryParamsToUrl(`${host}/clients/catalogs/export?order_by=name`, {...options, alreadyHasQueryParams: true})